import { AgeVerificationStatus } from "@next-platform/packages-ts-types";
import { isAgeVerificationMandatory, isAgeVerificationOptional, isAgeVerificationVerified } from "@next-platform/client-common-core";

import { getAgeVerificationModalShownFlag } from "./ageVerificationModalStorage";

/**
 * return true if the age verification warning should be displayed
 * @param ageVerificationStatus - current AgeVerificationStatus
 */
export function isAgeVerificationWarningModalNeeded(ageVerificationStatus?: AgeVerificationStatus | string): boolean {
  if (isAgeVerificationMandatory(ageVerificationStatus)) {
    // mandatory status should always display the warning modal
    return true;
  }
  if (isAgeVerificationVerified(ageVerificationStatus)) {
    // verified users should not see the warning modal again
    return false;
  }
  const age_verification_modal_shown = getAgeVerificationModalShownFlag();
  if (!age_verification_modal_shown && isAgeVerificationOptional(ageVerificationStatus)) {
    // optional status should display the warning modal if the user has not seen it before
    return true;
  }
  return false;
}
